import * as React from "react";
import GoogleMapReact from 'google-map-react';
// import MarkerIcon from './assets/img/marker.svg';


const MarkerReactComponent = ({ lat, lng, text }) => (
    <div className="Marker" style={{ position: 'relative', transform: 'translate(-50%, -50%)' }}>
        <div className="Marker-info" style={{
            position: 'absolute',
            top: '-100px',
            left: '-70px',
            fontFamily: 'Avenir, sans-serif',
            fontWeight: '400',
            fontSize: '16px',
            color: '#000',
            background: '#FFF',
            padding: '15px 10px',
            display: 'flex',
            borderRadius: '3px',
            width: '200px',
            height: '90px',
            boxShadow: '0 2px 8px 0 rgba(0, 0, 0, 0.16)',
        } as any}>
            {text}
        </div>
        {/*<MarkerIcon className="Marker-icon" />*/}
    </div>
);

interface Props {
    name?: any,
    lat?: any,
    lng?: any,
    center?: any,
    zoom?: any,
}

interface State {

}

export default class MapContainer extends React.Component<Props, State> {
    constructor(props) {
        super(props);
    }

    render() {
        const { name, lat, lng, center, zoom } = this.props;

        return (
            // Important! Always set the container height explicitly
            <div style={{ height: '100%', width: '100%' }}>
                <GoogleMapReact
                    center={center}
                    defaultZoom={zoom}
                >
                    <MarkerReactComponent
                        lat={lat}
                        lng={lng}
                        text={name}
                    />
                </GoogleMapReact>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/ui/MapContainer.tsx